import { ProyectoProducto } from "./proyectoProducto";

export class LineasProducto {
    nombre: string;
    idEmpresaAfiliada: number;
    idLineaProductos: number;
    idProyecto: number;
    idCategoria: number;
    estatus: number;
    descripcion: string;
    stock: number;
    cantidadGaleria: number;
    productos: ProyectoProducto[];
    tiendaActiva: boolean = false;
    tienda_linea_Activo: number = 0;
    cantidadProductos?: number = 0;
}